import { configureStore } from "@reduxjs/toolkit";
import userReducer from "../features/user/userSlice";
import { setupListeners } from "@reduxjs/toolkit/query";
import { yeapGoApi } from "../features/api/apiYeapGo";

export const store = configureStore({
  reducer: {
    user: userReducer,
    [yeapGoApi.reducerPath]: yeapGoApi.reducer,
  },
  // Adding the api middleware enables caching, invalidation, polling,
  // and other useful features of `rtk-query`.
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(yeapGoApi.middleware),
});

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch);
